import {getLogger} from "@goodgamestudios/logger";
export function info(...args): void {
    // TODO @HTML5 (logmeister was able to apply replacements - old CoreLogger too, but currently not supported);
    const [msg, ...rest] = args;
    getLogger("DEPRECATED").info(msg, ...rest);
}
